// https://www.investopedia.com/terms/p/primary-insurance-amount.asp
// contains 2020 values, Myle's values are for old 2019 values
export const AIMEVals = {
	2019: [
		{
			"low": 0,
			"high": 926,
			"rate": 0.9
		},
		{
			"low": 926,
			"high": 5583,
			"rate": 0.32
		},
		{
			"low": 5583,
			"high": Number.MAX_VALUE,
			"rate": 0.15
		}
	],
	2020: [
		{
			"low": 0,
			"high": 960,
			"rate": 0.9
		},
		{
			"low": 960,
			"high": 5785,
			"rate": 0.32
		},
		{
			"low": 5785,
			"high": Number.MAX_VALUE,
			"rate": 0.15
		}
	]
};

export const exemptionAmounts = {
	2019: { preFRA: 18240, yearOfFRA: 48600 },
};

export const FRAValues = {
	1937: { years: 65, months: 0 },
	1938: { years: 65, months: 2 },
	1939: { years: 65, months: 4 },
	1940: { years: 65, months: 6 },
	1941: { years: 65, months: 8 },
	1942: { years: 65, months: 10 },
	1943: { years: 66, months: 0 },
	1944: { years: 66, months: 0 },
	1945: { years: 66, months: 0 },
	1946: { years: 66, months: 0 },
	1947: { years: 66, months: 0 },
	1948: { years: 66, months: 0 },
	1949: { years: 66, months: 0 },
	1950: { years: 66, months: 0 },
	1951: { years: 66, months: 0 },
	1952: { years: 66, months: 0 },
	1953: { years: 66, months: 0 },
	1954: { years: 66, months: 0 },
	1955: { years: 66, months: 2 },
	1956: { years: 66, months: 4 },
	1957: { years: 66, months: 6 },
	1958: { years: 66, months: 8 },
	1959: { years: 66, months: 10 },
	1960: { years: 67, months: 0 },
};

export const YOCValues = {
	30: 0.9,
	29: 0.85,
	28: 0.8,
	27: 0.75,
	26: 0.7,
	25: 0.65,
	24: 0.6,
	23: 0.55,
	22: 0.5,
	21: 0.45,
	20: 0.4
};

export const widowValues = {
	60: .715,
	61: .763,
	62: .81,
	63: .858,
	64: .905,
	65: .953,
};